/**
 * Plain-text display for assistant replies (safety net when LLM uses markdown).
 */
export function formatAssistantText(content: string): string {
  let text = content;
  text = text.replace(/\*\*(.+?)\*\*/g, "$1");
  text = text.replace(/\*(.+?)\*/g, "$1");
  text = text.replace(/__(.+?)__/g, "$1");
  text = text.replace(/`([^`]+)`/g, "$1");
  text = text.replace(/^#{1,6}\s+/gm, "");
  text = text.replace(/^\s*[-*]\s+/gm, "• ");
  text = text.replace(/\|/g, " ");
  return text.trim();
}
